import { supabase } from '../../config/supabase';

export const updatePropertyStats = async (propertyId: string) => {
  try {
    // Get all monthly stats for the property
    const { data: monthlyStats, error: statsError } = await supabase
      .from('monthly_stats')
      .select('*')
      .eq('property_id', propertyId);

    if (statsError) throw statsError;

    // Calculate totals and averages
    const totals = monthlyStats?.reduce((acc, stat) => ({
      revenue: acc.revenue + Number(stat.revenue || 0),
      cleaning_costs: acc.cleaning_costs + Number(stat.cleaning_costs || 0),
      inmohost_costs: acc.inmohost_costs + Number(stat.inmohost_costs || 0),
      profit: acc.profit + Number(stat.profit || 0),
      occupancy_rate: acc.occupancy_rate + Number(stat.occupancy_rate || 0),
      reservations: acc.reservations + Number(stat.reservations || 0),
      average_night_price: acc.average_night_price + Number(stat.average_night_price || 0),
      average_stay_duration: acc.average_stay_duration + Number(stat.average_stay_duration || 0)
    }), {
      revenue: 0,
      cleaning_costs: 0,
      inmohost_costs: 0,
      profit: 0,
      occupancy_rate: 0,
      reservations: 0,
      average_night_price: 0,
      average_stay_duration: 0
    });

    const monthCount = monthlyStats?.length || 1;

    // Update property stats
    const { error: updateError } = await supabase
      .from('properties')
      .update({
        stats: {
          revenue: Math.round(totals.revenue),
          cleaning_costs: Math.round(totals.cleaning_costs),
          inmohost_costs: Math.round(totals.inmohost_costs),
          profit: Math.round(totals.profit),
          occupancy_rate: Math.round(totals.occupancy_rate / monthCount),
          reservations: totals.reservations,
          average_night_price: Math.round(totals.average_night_price / monthCount),
          average_stay_duration: Math.round(totals.average_stay_duration / monthCount)
        }
      })
      .eq('id', propertyId);

    if (updateError) throw updateError;

  } catch (error) {
    console.error('Error updating property stats:', error);
    throw error;
  }
};